<template>
  <div class="layout">
    <v-dialog />
    <div class="flex-row container">
      <side-bar-left />
      <Content />
      <side-bar-right />
    </div>
  </div>
</template>

<script>
import SideBarRight from "./SideBarRight.vue";
import SideBarLeft from "./SideBarLeft.vue";
import Content from "./Content.vue";

export default {
  components: { SideBarRight, SideBarLeft, Content },
  name: "MarkDownEditor",
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100vw;
  height: 100vh;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.container {
  height: 100%;
  width: 100%;
}
</style>
